
import CouponItem from './couponItem.vue'
export default {
    name: 'ConfirmChangePrice',
    components: {
        CouponItem
    },
    props: {
        orderDetail: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            isShow: false,
            couponList: [],
            selectedCoupon: null,
            loading: true,
            noUseCoupon: false,
            submitLoading: false
        }
    },
    computed: {
        couponPrice () {
            // 不使用优惠券
            if (this.noUseCoupon) {
                return 0
            }

            // 选了新优惠券
            if (this.selectedCoupon) {
                // 如果 coupon 不存在，直接返回 0
                if (!this.selectedCoupon) { return 0 }
                // 获取优惠券的基础属性
                const scopeBusiness = +this.selectedCoupon.scopeBusiness
                const couponsValue = +this.selectedCoupon.couponsValue

                // 定义补偿总金额
                const compensationPrice = +this.orderDetail.newCompensationFee

                // 根据优惠券适用范围计算抵扣金额
                if (scopeBusiness === 1) {
                    // 适用于包赔费用
                    return Math.min(compensationPrice, couponsValue)
                }
                else if (scopeBusiness === 2) {
                    // 适用于订单总价
                    const basicPrice = +this.orderDetail.newTransactionPrice
                    const totalPrice = basicPrice + compensationPrice
                    return Math.min(totalPrice.toFixed(2), couponsValue)
                }

                // 默认返回 0（未知业务类型）
                return 0
            }

            // 老优惠券 newCouponDiscount 原订单优惠券可用的情况下会自动挂上，否则为0
            if (+this.orderDetail.newCouponDiscount) {
                return +this.orderDetail.newCouponDiscount
            }

            return 0
        },
        // 订单金额 = 修改后号价 + 修改后包赔 - 新优惠券 - 号商折扣
        newOrderPrice () {
            const { newTransactionPrice, newCompensationFee, newMerchantDeductionAmount } = this.orderDetail
            const merchantDeductionAmount = newMerchantDeductionAmount || 0
            return Number(+(+newTransactionPrice + +newCompensationFee - this.couponPrice - merchantDeductionAmount).toFixed(2)) || '0.00'
        },
        // 已支付金额 = 修改前号价 + 修改前包赔 - 订单原始优惠券 - 修改前号商减免包赔金额
        paidPrice () {
            const { oldTransactionPrice, oldCompensationFee, oldCouponDiscount, oldMerchantDeductionAmount } = this.orderDetail
            const merchantDeductionAmount = oldMerchantDeductionAmount || 0
            return Number(+(+oldTransactionPrice + +oldCompensationFee - +oldCouponDiscount - merchantDeductionAmount).toFixed(2)) || '0.00'
        },
        // 合计补差 = 订单金额 - 已支付金额
        totalDifference () {
            return Number(+(this.newOrderPrice - this.paidPrice).toFixed(2)) || '0.00'
        }
    },
    methods: {
        // 获取优惠券列表
        async getCouponList () {
            const params = {
                gameId: this.orderDetail.gameId,
                price: this.orderDetail.newTransactionPrice,
                baseCompensationFee: this.orderDetail.baseCompensationFee,
                addCompensationFee: this.orderDetail.addCompensationFee,
                compensationId: this.orderDetail.compensationId
            }
            const res = await this.$api.getWaitUseCouponList(params)
            this.loading = false
            if (!res.success) {
                return this.$message.error(res.info)
            }
            this.couponList = res.data
        },
        // 选择优惠券
        selectCoupon (item) {
            if (!item.canUse) {
                return
            }
            this.noUseCoupon = false
            this.selectedCoupon = this.selectedCoupon === item ? null : item
        },
        // 选择不使用优惠券
        selectNoCoupon () {
            this.noUseCoupon = !this.noUseCoupon
            this.selectedCoupon = null
        },
        // 确认订单
        async confirmOrder () {
            try {
                let _noUseCoupon = this.noUseCoupon
                // 如果未选择优惠券且没有老优惠券，则默认不使用优惠券
                if (!this.selectedCoupon && !+this.orderDetail.newCouponDiscount) {
                    _noUseCoupon = true
                }
                const params = {
                    noUseCoupon: _noUseCoupon,
                    couponsCode: this.selectedCoupon?.couponsCode,
                    modifyOrderCardType: this.orderDetail.type,
                    idToken: this.orderDetail.idToken,
                    modifyOrderNo: this.orderDetail.modifyOrderNo,
                    orderId: this.orderDetail.orderId
                }
                this.submitLoading = true
                const res = await this.$api.changePriceConfirm(params)
                this.submitLoading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.isShow = false
            } catch (error) {
                this.submitLoading = false
            }
        },
        open () {
            this.isShow = true
            this.getCouponList()
        }
    }
}
